import { useEffect, useState } from "react";

import { TBeneficiariesContext } from "config";
import { AppError } from "config/errors";
import { useAppDispatch } from "store";
import { getBeneficiaries } from "store/actions/beneficiaries";
import { selectBeneficiariesByLineOfBusiness, useParamSelector } from "store/selectors";

export const useBeneficiariesData = (
  refresh = false,
  lineOfBusinessOrAssignedEntity: TBeneficiariesContext = "wysh-insurance"
) => {
  const dispatch = useAppDispatch();
  const [pending, setPending] = useState(refresh ? true : false);
  const [error, setError] = useState("");

  const { backup, beneficiaries } = useParamSelector(
    selectBeneficiariesByLineOfBusiness,
    lineOfBusinessOrAssignedEntity
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await dispatch(getBeneficiaries());

        setPending(false);
        const error = AppError.fromThunk(response);
        if (error) {
          throw error;
        }
      } catch (error) {
        setError(AppError.from(error).fullMessage);
      }
    };

    fetchData();
  }, [dispatch, refresh]);

  return {
    beneficiaries,
    backup,
    beneficiariesPending: pending,
    beneficiariesError: error,
  };
};
